import { wencesApi } from "@/api/wencesApi";

export const registerAction = async (
  name,
  password,
  email,
  restaurant,
  country,
  role,
  companyLink
) => {
  try {
    const { data } = await wencesApi.post("/api/users/register", {
      name,
      email,
      password,
      restaurant,
      country,
      role,
      companyLink,
    });

    if (data && data.ok) {
      return {
        ok: true,
        dedicatedAppWarning: data.dedicatedAppWarning || null,
        dedicatedAppDbName: data.dedicatedAppDbName || null,
        needsEmailConfirmation: data.needsEmailConfirmation === true,
        needsAdminActivation: data.needsAdminActivation === true,
        pendingDedicatedAppDbName: data.pendingDedicatedAppDbName || null,
      };
    }
    return {
      ok: false,
      message: (data && (data.error || data.message)) || "No se pudo crear el usuario",
    };
  } catch (error) {
    const msg =
      error.response?.data?.error ||
      error.response?.data?.message ||
      "No se pudo crear el usuario";
    return {
      ok: false,
      message: msg,
    };
  }
};

export const confirmAction = async (token) => {
  try {
    const { data } = await wencesApi.post(
      `/api/users/confirm-email/${encodeURIComponent(token)}`,
      { token }
    );
    if (data && data.ok === true) {
      return {
        ok: true,
        dedicatedAppDbName: data.dedicatedAppDbName || null,
      };
    }
    return {
      ok: false,
      message:
        (data && (data.error || data.message)) ||
        "No se pudo confirmar la cuenta",
    };
  } catch (error) {
    return {
      ok: false,
      message:
        error.response?.data?.error ||
        error.response?.data?.message ||
        "No se pudo confirmar la cuenta",
    };
  }
};

export const checkNameAction = async (name) => {
  try {
    const { data } = await wencesApi.post("/api/users/nameexists", { name });

    return {
      ok: true,
      exists: data.exists,
    };
  } catch (error) {
    console.log(error);
    return {
      ok: false,
      message: "No se pudo crear el usuario",
    };
  }
};
